
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Subscription } from '@/types/subscription';
import { formatDateForDisplay } from './dateFormatters';

// Use centralized date formatting to avoid timezone queries
export const formatDate = formatDateForDisplay;

export const getStatusBadge = (subscription: Subscription) => {
  if (!subscription.active || subscription.status === 'cancelled') {
    return <Badge variant="destructive">Cancelled</Badge>;
  }
  return <Badge variant="default">Active</Badge>;
};

export const getSubscriptionTypeBadge = (subscription: Subscription) => {
  if (subscription.isBusiness) {
    if (subscription.isAnnual) {
      return <Badge variant="outline" className="bg-purple-50 text-purple-700">Business Annual</Badge>;
    }
    return <Badge variant="outline" className="bg-purple-50 text-purple-700">Business Weekly</Badge>;
  }
  
  if (subscription.isAnnual) {
    return <Badge variant="outline" className="bg-green-50 text-green-700">Annual</Badge>;
  }
  return <Badge variant="outline" className="bg-blue-50 text-blue-700">Weekly</Badge>;
};
